import React, { useState } from "react";
import Button from "@mui/joy/Button";
import Add from "@mui/icons-material/Add";
import { useSelector } from "react-redux";

import ModalCreateEvent from "./ModalCreateEvent/ModalCreateEvent";

// La compañía llega por prop desde la compañía efectiva del panel (FTR-0012); ya no se lee de
// user.idcompany, que es NULL para el rol 1 sin restricción. El backend usa igualmente su contexto.
const CreateEventCompanyShortcut = ({ idcompany, deportes = [], onCreated }) => {
  const [open, setOpen] = useState(false);
  const iduser = useSelector((state) => state.auth.user?.iduser);

  return (
    <>
      <Button startDecorator={<Add />} onClick={() => setOpen(true)} disabled={!idcompany}>
        Crear Evento
      </Button>

      {open && idcompany && (
        <ModalCreateEvent
          open={open}
          setOpen={setOpen}
          idcompany={idcompany}
          iduser={iduser}
          companyMode
          deportes={deportes}
          onCreated={onCreated}
        />
      )}
    </>
  );
};

export default CreateEventCompanyShortcut;
